import {formatBusinessTimestamp} from 'src/api/business-time'

import type {RentalReport} from './schemas'

const UTF8_BOM = '\uFEFF'

const CSV_HEADERS = [
    'Status',
    'Asset',
    'Type',
    'Quantity',
    'Customer',
    'Order',
    'Location',
    'Days out',
    'Deployed date',
] as const

function escapeCsvField(value: string) {
    if (/[",\n\r]/.test(value)) {
        return `"${value.replaceAll('"', '""')}"`
    }
    return value
}

function formatDeployedDate(deployedAt: Date) {
    return formatBusinessTimestamp(deployedAt, 'MM/dd/yy')
}

export function buildRentalReportCsv(report: RentalReport) {
    const rows = report.rows.map((row) =>
        [
            row.status,
            row.assetDisplayName,
            row.rentalAssetTypeName,
            String(row.quantity),
            row.customerName,
            row.projectName,
            row.locationLabel,
            String(row.daysOut),
            formatDeployedDate(row.deployedAt),
        ].map(escapeCsvField),
    )

    const csvBody = [CSV_HEADERS.join(','), ...rows.map((row) => row.join(','))].join('\n')
    return `${UTF8_BOM}${csvBody}`
}

export function rentalReportCsvFilename(startDate: string, endDate: string) {
    return `rental-report-${startDate}-to-${endDate}.csv`
}

export function downloadRentalReportCsv(report: RentalReport) {
    const csv = buildRentalReportCsv(report)
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8'})
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = rentalReportCsvFilename(report.startDate, report.endDate)
    anchor.click()
    URL.revokeObjectURL(url)
}
